videojs.addLanguage('te', {
  "Audio Player": "ఆడియో ప్లేయర్",
  "Video Player": "వీడియో ప్లేయర్",
  "Play": "ప్లే",
  "Pause": "పాజ్",
  "Replay": "రీప్లే",
  "Current Time": "ప్రస్తుత సమయం",
  "Duration": "వ్యవధి",
  "Remaining Time": "మిగిలిన సమయం",
  "Stream Type": "స్ట్రీమ్ రకం",
  "LIVE": "లైవ్",
  "Seek to live, currently behind live": "ప్రత్యక్ష ప్రసారానికి వెళ్ళండి, ప్రస్తుతం ప్రత్యక్ష ప్రసారానికి వెనుకబడి ఉంది",
  "Seek to live, currently playing live": "ప్రత్యక్ష ప్రసారానికి వెళ్ళండి, ప్రస్తుతం ప్రత్యక్ష ప్రసారం అవుతోంది",
  "Loaded": "లోడ్ చేయబడింది",
  "Progress": "పురోగతి",
  "Progress Bar": "ప్రోగ్రెస్ బార్",
  "progress bar timing: currentTime={1} duration={2}": "{1} యొక్క {2}",
  "Fullscreen": "పూర్తి స్క్రీన్",
  "Non-Fullscreen": "పూర్తి స్క్రీన్ నుండి నిష్క్రమించండి",
  "Mute": "మ్యూట్",
  "Unmute": "అన్మ్యూట్ చేయండి",
  "Playback Rate": "ప్లేబ్యాక్ రేట్",
  "Subtitles": "ఉపశీర్షికలు",
  "subtitles off": "ఉపశీర్షికలు ఆఫ్ చేయండి",
  "Captions": "శీర్షికలు",
  "captions off": "శీర్షికలు ఆఫ్ చేయండి",
  "Chapters": "అధ్యాయాలు",
  "Descriptions": "వివరణలు",
  "descriptions off": "వివరణలు ఆఫ్ చేయండి",
  "Audio Track": "ఆడియో ట్రాక్",
  "Volume Level": "వాల్యూమ్ స్థాయి",
  "You aborted the media playback": "మీరు మీడియా ప్లేబ్యాక్‌ను రద్దు చేశారు",
  "A network error caused the media download to fail part-way.": "నెట్‌వర్క్ లోపం వలన మీడియా డౌన్‌లోడ్ విఫలమైంది.",
  "The media could not be loaded, either because the server or network failed or because the format is not supported.": "సర్వర్ లేదా నెట్‌వర్క్ విఫలమైనందున లేదా ఫార్మాట్‌కు మద్దతు లేనందున మీడియాను లోడ్ చేయడం సాధ్యం కాలేదు.",
  "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "అవినీతి సమస్య కారణంగా లేదా మీ బ్రౌజర్ మద్దతు ఇవ్వని లక్షణాలను మీడియా ఉపయోగించినందున మీడియా ప్లేబ్యాక్ నిలిపివేయబడింది.",
  "No compatible source was found for this media.": "ఈ మీడియాకు అనుకూలమైన మూలం కనుగొనబడలేదు.",
  "The media is encrypted and we do not have the keys to decrypt it.": "మీడియా గుప్తీకరించబడింది మరియు దానిని డీక్రిప్ట్ చేయడానికి మాకు కీలు లేవు.",
  "Play Video": "వీడియో ప్లే చేయండి",
  "Close": "మూసివేయండి",
  "Close Modal Dialog": "మోడల్ డైలాగ్‌ను మూసివేయండి",
  "Modal Window": "మోడల్ విండో",
  "This is a modal window": "ఇది మోడల్ విండో",
  "This modal can be closed by pressing the Escape key or activating the close button.": "ఎస్కేప్ కీని నొక్కడం ద్వారా లేదా క్లోజ్ బటన్‌ను యాక్టివేట్ చేయడం ద్వారా ఈ మోడల్‌ను మూసివేయవచ్చు.",
  ", opens captions settings dialog": ", శీర్షికల సెట్టింగ్‌ల డైలాగ్‌ను తెరుస్తుంది",
  ", opens subtitles settings dialog": ", ఉపశీర్షికల సెట్టింగుల డైలాగ్‌ను తెరుస్తుంది",
  ", opens descriptions settings dialog": ", వివరణల సెట్టింగుల డైలాగ్‌ను తెరుస్తుంది",
  ", selected": ", ఎంచుకోబడింది",
  "captions settings": "శీర్షికల సెట్టింగులు",
  "subtitles settings": "ఉపశీర్షికల సెట్టింగులు",
  "descriptions settings": "వివరణల సెట్టింగులు",
  "Text": "వచనం",
  "White": "తెలుపు",
  "Black": "నలుపు",
  "Red": "ఎరుపు",
  "Green": "ఆకుపచ్చ",
  "Blue": "నీలం",
  "Yellow": "పసుపు",
  "Magenta": "మెజెంటా",
  "Cyan": "సియాన్",
  "Background": "నేపధ్యం",
  "Window": "కిటికీ",
  "Transparent": "పారదర్శక",
  "Semi-Transparent": "సెమీ-పారదర్శక",
  "Opaque": "అపారదర్శక",
  "Font Size": "ఫాంట్ పరిమాణం",
  "Text Edge Style": "టెక్స్ట్ ఎడ్జ్ శైలి",
  "None": "ఏదీ లేదు",
  "Raised": "పెంచబడింది",
  "Depressed": "అణగారిన",
  "Uniform": "ఏకరీతి",
  "Dropshadow": "డ్రాప్‌షాడో",
  "Font Family": "ఫాంట్ కుటుంబం",
  "Proportional Sans-Serif": "ప్రొపోర్షన్ సాన్స్-సెరిఫ్",
  "Monospace Sans-Serif": "మోనోస్పేస్ సాన్స్-సెరిఫ్",
  "Proportional Serif": "ప్రొపోర్షన్ సెరిఫ్",
  "Monospace Serif": "మోనోస్పేస్ సెరిఫ్",
  "Casual": "సాధారణ",
  "Script": "స్క్రిప్ట్",
  "Small Caps": "చిన్న క్యాప్స్",
  "Reset": "రీసెట్ చేయండి",
  "restore all settings to the default values": "అన్ని సెట్టింగులను డిఫాల్ట్ విలువలకు పునరుద్ధరించండి",
  "Done": "పూర్తయింది",
  "Caption Settings Dialog": "శీర్షిక సెట్టింగ్‌ల డైలాగ్",
  "Beginning of dialog window. Escape will cancel and close the window.": "డైలాగ్ విండో ప్రారంభం. ఎస్కేప్ విండోను రద్దు చేస్తుంది మరియు మూసివేస్తుంది.",
  "End of dialog window.": "డైలాగ్ విండో ముగింపు.",
  "{1} is loading.": "{1} లోడ్ అవుతోంది.",
  "Exit Picture-in-Picture": "పిక్చర్-ఇన్-పిక్చర్ నుండి నిష్క్రమించండి",
  "Picture-in-Picture": "పిక్చర్-ఇన్-పిక్చర్"
});